import request from './request'

export function getVideoScriptList(data) {
  return request({
    url: '/videoScript/getVideoScriptList',
    method: 'post',
    data
  })
}

export function editVideoScript(data) {
  return request({
    url: '/videoScript/editVideoScript',
    method: 'post',
    data
  })
}

export function addVideoScript(data) {
  return request({
    url: '/videoScript/addVideoScript',
    method: 'post',
    data
  })
}

export function deleteVideoScript(data) {
  return request({
    url: '/videoScript/deleteVideoScript',
    method: 'post',
    data
  })
}

export function generateVideoScript(data) {
  return request({
    url: '/videoScript/generateVideoScript',
    method: 'post',
    data
  })
}

export function generateRecommendWords(data) {
  return request({
    url: '/videoScript/generateRecommendWords',
    method: 'post',
    data
  })
}

export function againGenerateRecommendWords(data) {
  return request({
    url: '/videoScript/againGenerateRecommendWords',
    method: 'post',
    data
  })
}

export function againGenerateVideoScript(data) {
  return request({
    url: '/videoScript/againGenerateVideoScript',
    method: 'post',
    data
  })
}

export function evaluateVideoScript(data) {
  return request({
    url: '/videoScript/evaluateVideoScript',
    method: 'post',
    data
  })
}

export function getVideoScriptInfo(data) {
  return request({
    url: '/videoScript/getVideoScriptInfo',
    method: 'post',
    data
  })
}

export function addClipCompose(data) {
  return request({
    url: '/videoScript/addClipCompose',
    method: 'post',
    data
  })
}

export function textToAudio(data) {
  return request({
    url: '/videoScript/textToAudio',
    method: 'post',
    data
  })
}
